module.exports = __webpack_public_path__ + "img/map.4d60b073.png";